import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/ui/app-ui/src/core/pages/bad-route.tsx");
